var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map-size"},[_c('input',{ref:"placeAutocomplete"}),_c('div',{ref:"mapLocation",staticClass:"map-size"})])
}
var staticRenderFns = []

export { render, staticRenderFns }